"use client";

import { useRouteChange } from "./RouteChangeProvider";
import { useEffect, useState } from "react";

export default function PageLoader() {
  const { loading } = useRouteChange();
  const [width, setWidth] = useState(0);

  useEffect(() => {
    let timer;
    if (loading) {
      setWidth(0);
      timer = setInterval(() => {
        setWidth((prev) => {
          if (prev >= 90) return prev;
          return prev + Math.random() * 10;
        });
      }, 100);
    } else {
      setWidth(100);
      timer = setTimeout(() => {
        setWidth(0);
      }, 300);
    }

    return () => clearInterval(timer);
  }, [loading]);

  return (
    <div className="fixed top-0 left-0 z-[9999] w-full h-1 bg-transparent pointer-events-none">
      <div
        className="h-full bg-blue-500 transition-all duration-200 ease-out"
        style={{
          width: `${width}%`,
          opacity: width === 0 ? 0 : 1,
        }}
      />
    </div>
  );
}
